import React from 'react'

type Props = {
  size?: number;
};

export const KoerberIcon: React.FC<Props> = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_174_911)">
        <path
          d="M8.57623 9.61693C8.78303 9.40927 8.9827 9.19445 9.17286 8.97246C8.21018 6.42325 7.71576 3.7189 7.71576 0.990668H3.05921C3.05921 4.56147 3.76042 8.09408 5.12007 11.3928C5.19613 11.5766 5.2722 11.758 5.35302 11.9394C6.5439 11.3474 7.63494 10.5645 8.57623 9.61693ZM8.76877 22.2484C5.98768 23.406 3.00929 24.0004 0 24.0004V16.3719C2.01095 16.3719 4.00288 15.9732 5.86169 15.2023C6.51062 14.9326 7.13577 14.6199 7.73953 14.2642C8.78066 13.6508 9.7481 12.9132 10.6205 12.0683L10.6228 12.0707C10.6941 12.0014 10.7631 11.9346 10.832 11.8654C12.2535 10.438 13.3825 8.74093 14.1527 6.87438C14.9228 5.00782 15.3174 3.0076 15.3174 0.988281H22.9143C22.9143 4.0101 22.3225 7.00327 21.1696 9.79356C20.0191 12.5862 18.3315 15.1211 16.2017 17.2574C15.9545 17.5056 15.7001 17.7491 15.441 17.9878C17.2594 19.5703 19.3203 20.8521 21.5499 21.7806C24.2692 22.912 27.1834 23.4944 30.1262 23.4944V28.1703C26.5725 28.1703 23.0522 27.4662 19.7672 26.1009C16.7531 24.8477 13.9934 23.0576 11.6164 20.821C10.706 21.3629 9.75285 21.8402 8.76877 22.2484Z"
          fill="#00522C"
        />
      </g>
      <defs>
        <clipPath id="clip0_174_911">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
